import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { ReportsState, getBrandsLoaded, LoadBrandsData } from '../store';
import { tap, take, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BrandsTabGuard  {

    constructor(private store: Store<ReportsState>) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const cacheKey: string = next.parent.params.cacheKey;
        return this.checkstore(cacheKey);
    }

    checkstore(cacheKey: string): Observable<boolean> {
        return this.store.pipe(
            select(getBrandsLoaded),
            tap(loaded => {
                if(!loaded)
                    this.store.dispatch(new LoadBrandsData(cacheKey))
            }),
            take(1),
            map(() => true)
        );
    }

}
